import React from "react";
import Link from "src/components/link";
import { getNavigationItemTarget } from "../navigationbar/navigationbar.target";

import { getLanguageField } from "src/utils/language";
import { getSlug } from "src/utils/slugs";

type Props = {
    key: string;
    depth: number;
    language: string;
    defaultLanguage: string;
    item: TNavigationItem;
}

export default class MobileNavigationLink extends React.Component<Props> {
    
    public get label(): string {
        return getLanguageField(this.props.item.translations, this.props.language, 'label') as string;
    }

    public get link(): string {
        return this.props.item.link_type === 'external'
            ? getLanguageField(this.props.item.link_translations, this.props.language, 'link_href') as string
            : getSlug(this.props.language, this.props.defaultLanguage, this.props.item.link_page?.translations || []);
    }

    public hasColor() {
        if (this.props.item.item_color) return true;
        return false;
    }
    
    public get color() {
        if (this.props.depth >= 2 && !this.hasColor()) return "text-[color:var(--link-subitems-text-color)]"
        return "text-[color:var(--text-color)] hover:text-[color:var(--hover-color)]";
    }

    public get font() {
        if (this.props.depth >= 2) return "navBarSubItems"
        return "navBarItems"
    }

    private get style(): any {
        return {
            '--text-color': this.props.item.item_color?.value,
            '--hover-color': this.props.item.item_hover_color?.value,
        }
    }
    
    render(): React.ReactNode {
        const {label, link} = this;
        return <Link style={this.style} key={this.props.key} title={label} href={link} target={getNavigationItemTarget(this.props.item)} className={`${this.font} mobile-navigation-link navigation-item-depth-${this.props.depth} ${this.color}`}>
            {label}
        </Link>
    }
}